module.exports = __webpack_public_path__ + "static/media/img_map.20e85046.png";